import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Grid,
  Header,
} from 'semantic-ui-react';

import { ScoreShape, TestShape } from '../shapes';

const ScaledScores = ({
  test, updateScore, existingScore, editMode,
}) => {
  const [scaledSubscores, setScaledSubscores] = useState([]);

  useEffect(() => {
    const getScaledSubcoreAttributes = () => {
      if (!editMode) {
        return scaledSubscores.map(subscore => ({
          score: subscore.val,
          growth_tracker_test_subscore_id: subscore.id,
        }));
      }

      return scaledSubscores.map((subscore) => {
        const scoreObj = existingScore
          .scaled_score_set
          .subscores
          .filter(sub => sub.growth_tracker_test_subscore.id === subscore.id)[0];
        if (scoreObj) {
          return {
            id: scoreObj.id,
            score: subscore.val,
            growth_tracker_test_subscore_id: subscore.id,
          };
        }

        return {
          score: subscore.val,
          growth_tracker_test_subscore_id: subscore.id,
        };
      });
    };

    if (editMode) {
      updateScore({
        growthTrackerScaledScoreSetAttributes: {
          id: existingScore.scaled_score_set.id,
          growth_tracker_subscores_attributes: getScaledSubcoreAttributes(),
        },
      });
    } else {
      updateScore({
        growthTrackerScaledScoreSetAttributes: {
          growth_tracker_subscores_attributes: getScaledSubcoreAttributes(),
        },
      });
    }
  }, [updateScore, editMode, scaledSubscores, existingScore]);

  useEffect(() => {
    if (!editMode) {
      return;
    }
    const scaledSubscoresObj = existingScore
      .scaled_score_set
      .subscores
      .map(subscore => ({ id: subscore.growth_tracker_test_subscore.id, val: subscore.score }));
    setScaledSubscores(scaledSubscoresObj);
  }, [editMode, existingScore]);


  const addOrUpdateScaledScore = (subscoreId, value) => {
    const scoresWithoutCurrentSubscore = scaledSubscores.filter(sub => sub.id !== subscoreId);
    setScaledSubscores([...scoresWithoutCurrentSubscore, { id: subscoreId, val: value }]);
  };

  return (
    <Grid.Column>
      <Header as="h4">Scaled Scores</Header>
      {test.subscores.map((subscore) => {
        const score = scaledSubscores.filter(sub => sub.id === subscore.id)[0];
        const scoreVal = score ? score.val : '';
        return (
          <Form.Group key={`scaled-subscore${subscore.id}`} unstackable>
            <Form.Field>
              <label>{subscore.name}</label>
              <Form.Input
                value={scoreVal}
                onChange={(e, { value }) => {
                  addOrUpdateScaledScore(subscore.id, value);
                }}
                placeholder="Enter score"
              />
            </Form.Field>
          </Form.Group>
        );
      })}
    </Grid.Column>
  );
};

ScaledScores.defaultProps = {
  editMode: false,
  existingScore: {},
};

ScaledScores.propTypes = {
  test: PropTypes.shape(TestShape).isRequired,
  editMode: PropTypes.bool,
  existingScore: PropTypes.shape(ScoreShape),
  updateScore: PropTypes.func.isRequired,
};

export default ScaledScores;
